import Typography from '@mui/material/Typography'
import {HealthConditionSubTitle} from '../HealthCondition/HealthConditionStyle'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'
import {Box, Grid} from '@mui/material'
import {ChatbotGrid, ToggleStack} from '../chatbot/ChatbotCopyStyle'

const TrendAnalysisComponent = ({selectedTrend, setselectedTrend}) => {
  const setselectedTogglefunction = () => {
    setselectedTrend([1 - selectedTrend[0]])
  }

  return (
    <Box tabIndex={0} aria-label='trend analysis'>
      <ChatbotGrid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HealthConditionSubTitle>
            Trend analysis displays trends for specific Health Conditions and Social Drivers of Health (SDOH). This will
            allow clients to view and analyze changes that occur over periods of time.
          </HealthConditionSubTitle>
        </Grid>
        <Grid item xs={12} md={6}>
          <ToggleStack>
            <Typography>Off</Typography>
            <TemporaryToggle
              checked={selectedTrend?.length > 0 ? selectedTrend[0] : false}
              onChange={setselectedTogglefunction}
              aria-label='Trend Analysis Toggle Button'
            />
            <Typography>On</Typography>
          </ToggleStack>
        </Grid>
      </ChatbotGrid>
    </Box>
  )
}

TrendAnalysisComponent.propTypes = {
  setselectedTrend: PropTypes.func,
  selectedTrend: PropTypes.array
}

export default TrendAnalysisComponent
